<template>
  <div class="index">
    <van-nav-bar title="" left-text="" @click-left="toService" left-arrow fixed>
      <template #title>
        <div class="van-image" style="width: 90px;">
          <img src="img/logo.png" class="van-image__img">
        </div>
      </template>
      <template #left>
        <van-icon name="chat-o" size="26" />
      </template>
    </van-nav-bar>

    <div class="banner banners" style="margin-top: 5px;height: 10rem;">
      <swiper class="swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v,key) in banners" :key="key">
          <a>
            <img class="banner_img" :src="v.url" />
          </a>
        </swiper-slide>
      </swiper>
    </div>

    <div class="video-section">
      <div class="video-section-title">推薦影片</div>
      <div class="recommend-scroll">
        <ul class="recommend-grid">
          <li v-for="(v,key) in recommendVideos" :key="'r-' + key" @click="toPlayVideo(v.id)">
            <img :src="v.vod_pic || v.image" alt="">
            <div>
              <span>{{ v.vod_name || v.class_name }}</span>
              <span>播放:{{ v.count || 0 }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="video-section">
      <div class="video-section-title">熱門視頻</div>
      <van-list
        v-model="hotLoading"
        :finished="hotFinished"
        :immediate-check="false"
        finished-text="沒有更多了"
        @load="loadHotVideos"
      >
        <ul class="video-grid">
          <li v-for="(v,key) in hotVideos" :key="'h-' + key" @click="toPlayVideo(v.id)">
            <img :src="v.vod_pic || v.image" alt="">
            <div>
              <span>{{ v.vod_name || v.class_name }}</span>
              <span>播放:{{ v.count || 0 }}</span>
            </div>
          </li>
        </ul>
      </van-list>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: '获取中......',
      banners: [
        { url: '/img/club1.jpg' },
        { url: '/img/club2.jpg' },
        { url: '/img/club3.jpg' },
      ],
      basicData: [],
      vip_list: [],
      isLoading: false,
      recommendVideos: [],
      hotVideos: [],
      videoClasses: [],
      recommendClassId: 0,
      hotClassId: 0,
      hotPage: 1,
      hotCount: 0,
      hotLoading: false,
      hotFinished: false,
      bannerSwiperOption: {
        loop: true,
        speed: 1000,
        autoplay: true,
      },
      vipSwiperOption: {
        direction: 'vertical',
        slidesPerView: 7,
        loop: true,
        speed: 1000,
        autoplay: true,
      },
    };
  },
  methods: {
    resolveClassId(item, fallback = 0) {
      if (!item || typeof item !== 'object') return fallback;
      if (item.key !== undefined && item.key !== null && String(item.key) !== '') return item.key;
      if (item.id !== undefined && item.id !== null && String(item.id) !== '') return item.id;
      if (item.value !== undefined && item.value !== null && String(item.value) !== '') return item.value;
      return fallback;
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push('ServiceOnline');
      } else {
        this.$toast(this.$t('common.refresh'));
      }
    },
    toPlayVideo(id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' });
      } else {
        this.$router.push({ path: '/PlayVideo?id=' + id });
      }
    },
    async initVideoSections() {
      const clsRes = await this.$http({
        method: 'get',
        url: 'video_class',
      });
      this.videoClasses = clsRes && clsRes.data ? clsRes.data : [];
      const firstClass = this.resolveClassId(this.videoClasses[0], 0);
      const secondClass = this.resolveClassId(this.videoClasses[1], firstClass);
      this.recommendClassId = firstClass;
      this.hotClassId = secondClass;
      await this.getRecommendVideos();
      this.resetHotVideos();
      this.loadHotVideos();
    },
    async getRecommendVideos() {
      let res = await this.$http({
        method: 'get',
        data: { id: this.recommendClassId, page: 1 },
        url: 'video_list',
      });
      let list = res && res.data && res.data.data ? res.data.data : [];
      // 兜底：部分环境首页分类 id 可能不一致，回退到影视馆默认 id=0
      if (!list.length && this.recommendClassId !== 0) {
        res = await this.$http({
          method: 'get',
          data: { id: 0, page: 1 },
          url: 'video_list',
        });
        list = res && res.data && res.data.data ? res.data.data : [];
      }
      this.recommendVideos = list;
    },
    resetHotVideos() {
      this.hotVideos = [];
      this.hotPage = 1;
      this.hotCount = 0;
      this.hotFinished = false;
    },
    async loadHotVideos() {
      if (this.hotFinished) return;
      let res = await this.$http({
        method: 'get',
        data: { id: this.hotClassId, page: this.hotPage },
        url: 'video_list',
      });
      let list = res && res.data && res.data.data ? res.data.data : [];
      let count = res && res.data && res.data.count ? res.data.count : 0;
      if (!list.length && this.hotClassId !== 0) {
        res = await this.$http({
          method: 'get',
          data: { id: 0, page: this.hotPage },
          url: 'video_list',
        });
        list = res && res.data && res.data.data ? res.data.data : [];
        count = res && res.data && res.data.count ? res.data.count : 0;
      }
      this.hotCount = count;
      this.hotVideos = this.hotVideos.concat(list);
      this.hotPage += 1;
      if (!list.length || this.hotVideos.length >= this.hotCount) {
        this.hotFinished = true;
      }
      this.hotLoading = false;
    },
    getBasicConfig() {
      this.$http({
        method: 'get',
        url: 'sys_config',
      }).then((res) => {
        this.basicData = res.data || {};
        this.vip_list = this.basicData.vip_list;
        this.notice = this.basicData.notice;
        // 轮播图改用本地 public/img/club1~3.jpg，不再取接口 banners
      });
    },
  },
  created() {
    this.getBasicConfig();
    this.initVideoSections();
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

.van-nav-bar {
  z-index: 999;
  position: absolute;
  background: url(/img/header.svg) no-repeat 50%/100%;
}

.video-section {
  padding: 0 10px;
}

.video-section-title {
  display: block;
  width: fit-content;
  background: #46385d;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  padding: 6px 14px;
  border-radius: 4px;
  margin: 12px 0 6px;
  text-align: left;
}

.recommend-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.recommend-grid {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, 1fr);
  grid-auto-columns: calc(50% - .33333rem);
  gap: .66667rem .66667rem;
  padding-bottom: .2rem;
}

.video-grid {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
}

.video-grid li,
.recommend-grid li {
  border-radius: .33333rem;
  overflow: hidden;
  margin-top: .66667rem;
  height: 6.66667rem;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video-grid li {
  width: calc(50% - .33333rem);
}

.video-grid li img,
.recommend-grid li img {
  width: 100%;
  height: 100%;
}

.video-grid li > div,
.recommend-grid li > div {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,.4);
  padding: .33333rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-grid li > div span,
.recommend-grid li > div span {
  color: #fff;
  font-size: .8rem;
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 .33333rem;
}
</style>
